// extracted by mini-css-extract-plugin
module.exports = {"reqMsg":"CopyToClipboard--reqMsg--W20nXFo"};